import { Breadcrumb, Checkbox, Col, ConfigProvider, DatePicker, Flex, Popover, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as LeftArrowIcon } from "../../../assets/icon/leftArrowIcon.svg";
import { ReactComponent as RightArrowIcon } from "../../../assets/icon/rightArrowIcon.svg";
import { useCallback, useState } from "react";
import dayjs from "dayjs";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';
import styles from "../../employee/styles/EmployeeWorkinCalendar.module.css";
import { Calendar, dayjsLocalizer } from "react-big-calendar";
import { useSelector } from "react-redux";
import MyTeamLeaveCalendarModal from "./MyTeamLeaveCalendarModal";

const MyTeamLeaveCalendar = ({
    shiftColor = [],
    employeeRequestCalendar = [],
    processedEvents = () => { },
    onChange = () => { },
    eventPropGetter = () => { },
    isLeaveHrView = false,
    handleHrViewChange = () => { },
    handleSelectEvent = () => { },
    getPopoverContent = () => { },
    handlePopoverVisibleChange = () => { },
    popoverVisible = false,
    isDetailModalOpen = false,
    setIsDetailModalOpen = () => { },
    selectedDate = "",
    selectedEmployeeList = [],
    transformEmployeeRequestsForModal = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const localizer = dayjsLocalizer(dayjs)
    const [date, setDate] = useState(new Date());
    const { roles } = useSelector((state) => state.company);

    function localeFn() {
        if (i18n.language === 'en') {
            return localeEn
        } else {
            return {
                ...localeTh,
                lang: {
                    ...localeTh.lang,
                    yearFormat: "BBBB",
                    dateFormat: "D/M/BBBB",
                    cellYearFormat: "BBBB"
                }
            }
        }
    }

    const onPrevClick = useCallback(() => {
        const newDate = dayjs(date).subtract(1, "month").toDate();
        setDate(newDate);
        onChange(dayjs(newDate));
    }, [date, onChange]);

    const onNextClick = useCallback(() => {
        const newDate = dayjs(date).add(1, "month").toDate();
        setDate(newDate);
        onChange(dayjs(newDate));
    }, [date, onChange]);

    const handleDateChange = (value) => {
        if (!value) return;
        const newDate = dayjs(value).startOf("month").toDate();
        setDate(newDate);
        onChange(dayjs(newDate));
    };


    return (
        <Space style={{ width: "100%" }} size={24} direction="vertical">
            <MyTeamLeaveCalendarModal
                isOpen={isDetailModalOpen}
                setIsDetailModalOpen={setIsDetailModalOpen}
                selectedDate={selectedDate}
                employeeList={selectedEmployeeList}
                onClose={() => { setIsDetailModalOpen(false) }}
            />

            <Flex vertical>
                <Breadcrumb items={[
                    { title: t("home.header"), href: "/" },
                    { title: t("my_team.header"), href: "" },
                    { title: t("leave_calendar.header") },
                ]} />
                <h2>{t("leave_calendar.header")}</h2>
            </Flex>

            <Flex>
                <Col span={6} style={{ textAlign: "start", alignContent: "center" }}>
                    {roles.includes("ROLE_HR") ?
                        <Flex gap={8} align="center">
                            <Checkbox
                                checked={isLeaveHrView}
                                onChange={handleHrViewChange}
                            />
                            <span>{t("calendar.label.hr_view")}</span>
                        </Flex>
                        : null}
                </Col>
                <Col span={9}>
                    <Flex justify="center">
                        <LeftArrowIcon
                            onClick={onPrevClick}
                            style={{ cursor: "pointer", alignSelf: "center", width: "8px" }}
                        />
                        <ConfigProvider theme={{
                            components: {
                                DatePicker: {
                                    colorBgContainer: "transparent"
                                }
                            }
                        }}>
                            <DatePicker
                                allowClear={false}
                                value={dayjs(date)}
                                onChange={handleDateChange}
                                format={() => dayjs(date).format(i18n.language === "en" ? "MMMM YYYY" : "MMMM BBBB")
                                }
                                picker={"month"}
                                locale={localeFn()}
                                suffixIcon={null}
                                className={styles.datePicker}
                                style={{ width: "200px", textAlignLast: "center" }}
                            />

                        </ConfigProvider>
                        <RightArrowIcon
                            onClick={onNextClick}
                            style={{ cursor: "pointer", alignSelf: "center", width: "8px" }}
                        />
                    </Flex>
                </Col>
            </Flex>

            <Calendar
                localizer={localizer}
                events={processedEvents}
                startAccessor="start"
                endAccessor="end"
                view="month"
                date={date}
                onNavigate={setDate}
                toolbar={false}
                eventPropGetter={eventPropGetter}
                onSelectEvent={handleSelectEvent}
                // style={{ minHeight: "800px", width: "100%" }}
                components={{
                    event: ({ event }) => {
                        const eventId = `${event.id}`;

                        if (event.resource.type === 'leave' || event.resource.type === 'offsite') {
                            return (
                                <Popover
                                    content={getPopoverContent(event)}
                                    title={null}
                                    trigger="click"
                                    open={popoverVisible[eventId]}
                                    onOpenChange={(visible) => handlePopoverVisibleChange(eventId, visible)}
                                    placement="top"
                                    overlayStyle={{ width: '300px' }}
                                    overlayInnerStyle={{ width: '100%' }}
                                >
                                    <span style={{ cursor: 'pointer' }}>
                                        {event.title}
                                    </span>
                                </Popover>
                            );
                        }

                        if (event.resource.type === 'seeMore') {
                            return (
                                <span style={{ cursor: 'pointer' }}>
                                    {event.title}
                                </span>
                            );
                        }

                        return <span>{event.title}</span>;
                    }
                }} />

            <Flex gap={8} style={{ alignItems: "center", flexWrap: "wrap" }}>
                {shiftColor.slice(0, 4).map((shift, index) => (
                    <Col span={[0].includes(index) ? 4 : [1].includes(index) ? 7 : 5}>
                        <Flex key={index} gap={8} style={{ alignItems: "center" }}>
                            <div
                                style={{
                                    backgroundColor: shift.color,
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                }}
                            />
                            <Tag
                                color={shift.bgColor}
                                style={{ borderRadius: "4px", width: "max-content" }}
                            >
                                <span style={{ color: shift.color }}>
                                    {i18n.language === "en" ? shift.nameEn : shift.name}
                                </span>
                            </Tag>
                        </Flex>
                    </Col>
                ))}
            </Flex>
        </Space>
    )
}

export default MyTeamLeaveCalendar;